import React from "react";
import { connect } from "react-redux";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { IAppState } from "../../redux/reducers";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";
import { commonActions } from "../../redux/actions/common";
import styles from "./top-nav.module.scss";
import Button from "../shared-ui/button";
import { Link } from "react-router-dom";
import logoPng from "../../assets/myota_logo_white_type.png";

const mapStateToProps = (state: IAppState) => ({
  isLeftOpen: state.common.isLeftPanelOpen,
  isRightOpen: state.common.isRightNavOpen,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    setLeftPanelOpen: val => dispatch(commonActions.setLeftPanelOpen(val)),
    setRightNavOpen: val => dispatch(commonActions.setRightNavOpen(val)),
  };
};

interface ITopNavProps
  extends ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {}

const TopNav = connect(
  mapStateToProps,
  mapDispatchToProps
)((props: ITopNavProps) => {
  return (
    <div className={styles.root}>
      <Button
        testId="menu-button"
        onClick={() => props.setLeftPanelOpen(!props.isLeftOpen)}
        className={styles.menu}
      >
        <MenuIcon />
      </Button>
      <div className={styles.logo}>
        <Link to="/">
          <img src={logoPng} alt="Myota-logo" />
        </Link>
      </div>
      <Button
        testId="account-button"
        onClick={() => props.setRightNavOpen(!props.isRightOpen)}
        className={styles.account}
      >
        <AccountCircleIcon className={styles.icon} />
      </Button>
    </div>
  );
});

export default TopNav;
